import { Box, Container, Typography, Divider, Stack } from "@mui/material";
import { Loading } from "src/components/utils/Loading";
import { useApplicationParameters } from "src/api/client-api/appParams";
import { Theme } from "./Fields/Theme";
import { BaseIconUpload } from "./BaseIconUpload";
import { BaseStringUpload } from "./BaseStringUpload";
import { BaseToggleUpload } from "./BaseToggleUpload";
import { ActionPlanModal } from "./ExtraConfiguration/ActionPlanModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const AppParamsSettings = () => {
    const { t } = useTranslation();
    const { applicationParameters } = useApplicationParameters();
    const [isActionPlanModalOpen, setActionPlanModalOpen] = useState(false);

    if (applicationParameters === undefined) return <Loading />;

    return (
        <Container
            component="main"
            maxWidth={false}
            sx={{
                m: "0",
                p: "5rem !important",
            }}
        >
            <Typography variant="h1">{t("settings.app_params.title", "Paramètres")}</Typography>
            <Typography variant="big-bold">
                {t("settings.app_params.description", "Please, validate your changes one field at a time.")}
            </Typography>
            <Box sx={{ py: 2 }} />
            <Divider />
            <Box sx={{ py: 2 }} />

            <Stack gap={"30px"}>
                <Theme currentTheme={applicationParameters.theme ?? null} />
                <Divider />
                <BaseStringUpload
                    label={"Title of the tab"}
                    description={"This appears on the very top of your browser"}
                    appParamKey={"tabTitle"}
                />
                <Divider />
                <Stack flexDirection={"row"} gap={"75px"}>
                    <BaseIconUpload
                        label={"Fav icon"}
                        description={"This represents the Icon of your tab, and in your favorites"}
                        appParamKey={"tabIcon"}
                    />
                    <BaseIconUpload label={"Logo"} description={"Main logo image"} appParamKey={"logo"} />
                    <BaseIconUpload
                        label={"Logo Square"}
                        description={"Square logo used in the sidebar organization avatar"}
                        appParamKey={"logoSquare"}
                    />
                </Stack>
                <Divider />
                <BaseStringUpload
                    label={"Freshdesk Widget ID"}
                    description={"ID of the Freshdesk window that appears on the screen"}
                    appParamKey="freshdeskWidgetId"
                />
                <Divider />
                <BaseToggleUpload
                    appParamKey={"FS-cms-enabled"}
                    label={"CMS"}
                    description={
                        "Feature switch of the new Page manager of the app,\
                         be careful if the 'Page CMS V1' feature is activated the CMS will be added next to the old CMS homepage content"
                    }
                />
                <BaseToggleUpload
                    appParamKey={"FS-strategy"}
                    label={"Page stratégie"}
                    description={"Feature switch of Stratégie"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-company-score-details-comparison"}
                    label={"Page Diagnostic: Score > Comparison"}
                    description={"Feature switch of Comparaison module"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-company-score-details-distribution"}
                    label={"Page Diagnostic: Score > Distribution"}
                    description={"Feature switch of Distribution module"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-actionPlan"}
                    label={"Page Action Plan"}
                    description={"Feature switch of Action Plan module"}
                    extraConfiguration={() => {
                        setActionPlanModalOpen(true);
                    }}
                />
                <BaseToggleUpload
                    appParamKey={"FS-documentary-space"}
                    label={"Documentary Space Page"}
                    description={"Feature switch to activate/deactivate the Documentary Space Page"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-ssq-export-excel"}
                    label={"Export SSQ content as Excel"}
                    description={"Feature switch of export SSQ content as Excel module"}
                />
                <BaseToggleUpload
                    appParamKey={"FS-legal-requirement"}
                    label={"Legal Requirements"}
                    description={"Feature switch for the legal requirements section in company page"}
                />
                <ActionPlanModal isOpen={isActionPlanModalOpen} setOpen={setActionPlanModalOpen} />
            </Stack>
            <Box sx={{ py: 2 }} />
        </Container>
    );
};
